export default "__VITE_ASSET__B_$C9lx___"